import { put, retry, takeEvery } from 'redux-saga/effects';
import getExternalSelectOptionsQuery from './getExternalSelectOptionsQuery';
import ActionTypes from '../../../../Data/ActionTypes';

export function* getExternalSelectOptionsWorker(action) {
  const maxTries = 3;
  const delayLength = 1000;
  const { payload } = action;
  const { componentId, type, data } = payload;

  const dataWithoutEmptyValues = data?.filter(
    (item) => item.value !== undefined
  );

  try {
    const requestArguments = {
      type,
      data: dataWithoutEmptyValues,
    };

    const args = {
      variables: requestArguments,
    };

    const options = yield retry(
      maxTries,
      delayLength,
      getExternalSelectOptionsQuery,
      args
    );

    const optionsWithMandatoryFields = options.map((option) => ({
      ...option,
      id: option.value,
      key: option.value,
    }));
    if (optionsWithMandatoryFields.length > 0) {
      yield put({
        type: 'COMPONENTS/setExternalOptions',
        payload: {
          componentId,
          options: optionsWithMandatoryFields,
        },
      });
    }
  } catch (error) {
    yield put({
      type: 'GET_EXTERNAL_SELECT_OPTIONS_FAILED',
      payload: {},
    });
  }
}

export const getExternalSelectOptionsAction = (componentId, type, data) => ({
  type: ActionTypes.GET_EXTERNAL_SELECT_OPTIONS,
  payload: {
    componentId,
    type,
    data,
  },
});

export default function* getExternalSelectOptions() {
  yield takeEvery(
    ActionTypes.GET_EXTERNAL_SELECT_OPTIONS,
    getExternalSelectOptionsWorker
  );
}
